import { render, staticRenderFns } from "./Excursies.vue?vue&type=template&id=27ed3e93&scoped=true"
import script from "./Excursies.vue?vue&type=script&lang=ts"
export * from "./Excursies.vue?vue&type=script&lang=ts"
import style0 from "./Excursies.vue?vue&type=style&index=0&id=27ed3e93&prod&scoped=true&lang=css"
import style1 from "./Excursies.vue?vue&type=style&index=1&id=27ed3e93&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ed3e93",
  null
  
)

export default component.exports